"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    land: function() {
        return land;
    },
    adresseOgLand: function() {
        return adresseOgLand;
    },
    bolig: function() {
        return bolig;
    },
    fastEiendom: function() {
        return fastEiendom;
    },
    formatertTekst: function() {
        return formatertTekst;
    },
    kombinert: function() {
        return kombinert;
    },
    tilhoerendeEiendom: function() {
        return tilhoerendeEiendom;
    },
    fnrTilFoedselsdato: function() {
        return fnrTilFoedselsdato;
    }
});
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _compact = /*#__PURE__*/ _interop_require_default(require("lodash/compact"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _flattenDepth = /*#__PURE__*/ _interop_require_default(require("lodash/flattenDepth"));
var _isArray = /*#__PURE__*/ _interop_require_default(require("lodash/isArray"));
var _pickBy = /*#__PURE__*/ _interop_require_default(require("lodash/pickBy"));
var _kodeliste = require("./kodeliste");
var _transformKonstanter = require("./transformKonstanter");
var _utils = require("../../validering/utils");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var erUtland = function(data) {
    return data.landkode && data.landkode !== "NO";
};
var formaterEiendomsinfoOgSted = function(eiendom, options) {
    var eiendomstype = eiendom.eiendomstype, kommunenummer = eiendom.kommunenummer, boligBruk = eiendom.boligBruk, boligbruk = eiendom.boligbruk;
    var boligbrukFelt = boligbruk || boligBruk;
    var _options_inntektsaar = options.inntektsaar, inntektsaar = _options_inntektsaar === void 0 ? "2018" : _options_inntektsaar, _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl, forhaandsfastsettingFormat = options.forhaandsfastsettingFormat;
    var tekniskInntektsaar = forhaandsfastsettingFormat === "fjoraaretsSkattemelding" ? inntektsaar - 1 : inntektsaar;
    var kodelisteIdEiendomstype = (0, _kodeliste.kodelisteId)("".concat(tekniskInntektsaar, "_eiendomstype.").concat(eiendomstype));
    var txtEiendomInfo = intl.formatMessage({
        id: kodelisteIdEiendomstype
    });
    if (eiendomstype === undefined) {
        txtEiendomInfo = "";
    }
    if ((eiendomstype === "selveidBolig" || eiendomstype === "boenhetIBoligselskap") && boligbrukFelt) {
        var kodelisteIdBoligbruk = (0, _kodeliste.kodelisteId)("".concat(tekniskInntektsaar, "_boligbruk.").concat(boligbrukFelt));
        txtEiendomInfo = intl.formatMessage({
            id: kodelisteIdBoligbruk
        });
    }
    var kodelisteIdKommunenummer = (0, _kodeliste.kodelisteId)("".concat(inntektsaar, "_aktiveKommunenummer.").concat(kommunenummer));
    var txtKommune = intl.formatMessage({
        id: kodelisteIdKommunenummer
    });
    var txtKommuneInfo = inline ? "".concat(txtKommune, " (").concat(kommunenummer, ")") : /*#__PURE__*/ _react.default.createElement("span", null, txtKommune, " (", kommunenummer, ")");
    var iEllerPaa = kommunenummer === "2100" ? "p\xe5" : "i";
    if (inline) {
        if (!kommunenummer) {
            return "".concat(txtEiendomInfo);
        }
        return "".concat(txtEiendomInfo, " ").concat(iEllerPaa, " ").concat(txtKommuneInfo);
    }
    return (eiendomstype || kommunenummer) && /*#__PURE__*/ _react.default.createElement("span", null, eiendomstype && txtEiendomInfo, eiendomstype && kommunenummer && " ".concat(iEllerPaa, " "), kommunenummer && txtKommuneInfo);
};
var formaterEiendomAdresse = function(eiendom, intl) {
    var adressenavn = eiendom.adressenavn, husnummer = eiendom.husnummer, husbokstav = eiendom.husbokstav, postnummer = eiendom.postnummer, poststedsnavn = eiendom.poststedsnavn, gaardsnummer = eiendom.gaardsnummer, bruksnummer = eiendom.bruksnummer, seksjonsnummer = eiendom.seksjonsnummer, festenummer = eiendom.festenummer, aksjeboenhetsnummer = eiendom.aksjeboenhetsnummer, andelsnummer = eiendom.andelsnummer, bruksenhetsnummer = eiendom.bruksenhetsnummer, boligensAreal = eiendom.boligensAreal, byggeaar = eiendom.byggeaar, _eiendom_harDuplikateSergId = eiendom.harDuplikateSergId, harDuplikateSergId = _eiendom_harDuplikateSergId === void 0 ? false : _eiendom_harDuplikateSergId;
    var adresseinfo = (0, _compact.default)([
        (0, _compact.default)([
            adressenavn,
            (0, _compact.default)([
                husnummer,
                husbokstav
            ]).join("")
        ]).join(" "),
        (0, _compact.default)([
            postnummer,
            poststedsnavn
        ]).join(" ")
    ]).join(", ");
    var gnr = !!parseInt(gaardsnummer, 10) && "Gnr. ".concat(gaardsnummer);
    var bnr = !!parseInt(bruksnummer, 10) && "Bnr. ".concat(bruksnummer);
    var snr = !!parseInt(seksjonsnummer, 10) && "Seksjonsnr. ".concat(seksjonsnummer);
    var fnr = !!parseInt(festenummer, 10) && "Festenr. ".concat(festenummer);
    var matrikkelinfo = !aksjeboenhetsnummer && !andelsnummer && (0, _compact.default)([
        gnr,
        bnr,
        snr,
        fnr
    ]).join(" ");
    var andelsnr = andelsnummer && "Andelsnummer ".concat(andelsnummer);
    var aksjeboenhetsnr = aksjeboenhetsnummer && "Aksjeboenhetsnummer ".concat(aksjeboenhetsnummer);
    var bolignr = (aksjeboenhetsnummer || andelsnummer) && bruksenhetsnummer && "Bolignummer ".concat(bruksenhetsnummer);
    var boligInfo = harDuplikateSergId && (0, _compact.default)([
        boligensAreal && "".concat(intl.formatMessage({
            id: "formuesgrunnlagSelveidBolig.boligensAreal"
        }), ": ").concat(boligensAreal),
        byggeaar && "".concat(intl.formatMessage({
            id: "formuesgrunnlagSelveidBolig.byggeaar"
        }), ": ").concat(byggeaar)
    ]).join(", ");
    return {
        adresseinfo: adresseinfo,
        matrikkelinfo: matrikkelinfo,
        andelsnr: andelsnr,
        aksjeboenhetsnr: aksjeboenhetsnr,
        bolignr: bolignr,
        boligInfo: boligInfo
    };
};
var land = {
    navn: "Land",
    description: "Denne transformeren benyttes ved visning av land",
    transform: function transform(felt, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _options_inntektsaar = options.inntektsaar, inntektsaar = _options_inntektsaar === void 0 ? "2018" : _options_inntektsaar, _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl;
        var land = formaterLandFraKodeliste(intl, inntektsaar, data.landkode);
        if (inline) {
            return land;
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, land);
    }
};
var adresseOgLand = {
    navn: "Adresse og land",
    description: "Denne transformeren benyttes ved visning av adresse og land",
    transform: function transform(felt, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _options_inntektsaar = options.inntektsaar, inntektsaar = _options_inntektsaar === void 0 ? "2018" : _options_inntektsaar, _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl;
        var land = formaterLandFraKodeliste(intl, inntektsaar, data.landkode);
        if (inline) {
            return (0, _compact.default)([
                data.adressenavn,
                land
            ]).join(", ");
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, /*#__PURE__*/ _react.default.createElement("div", null, data.adressenavn), land);
    }
};
var bolig = {
    navn: "Adresseinfo",
    description: "Denne transformeren er veldig spesifikk for bolig. Den viser frem adresseinfo gitt et objekt som kommer fra serg.",
    transform: function transform(felt, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _options_inntektsaar = options.inntektsaar, inntektsaar = _options_inntektsaar === void 0 ? "2018" : _options_inntektsaar, _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl, visKommune = options.visKommune;
        var landkode = data.landkode, adresse = data.adresse, adressenavn = data.adressenavn, kommunenummer = data.kommunenummer;
        if (erUtland(data)) {
            var txtLand = formaterLandFraKodeliste(intl, inntektsaar, landkode);
            var txtAdresse = adresse || adressenavn || "";
            if (inline) {
                return (0, _compact.default)([
                    txtLand,
                    txtAdresse
                ]).join(", ");
            }
            return /*#__PURE__*/ _react.default.createElement("div", null, txtLand && /*#__PURE__*/ _react.default.createElement("div", null, txtLand), txtAdresse && /*#__PURE__*/ _react.default.createElement("div", null, txtAdresse));
        }
        var _formaterEiendomAdresse = formaterEiendomAdresse(data, intl), adresseinfo = _formaterEiendomAdresse.adresseinfo, matrikkelinfo = _formaterEiendomAdresse.matrikkelinfo, andelsnr = _formaterEiendomAdresse.andelsnr, aksjeboenhetsnr = _formaterEiendomAdresse.aksjeboenhetsnr, bolignr = _formaterEiendomAdresse.bolignr;
        if (visKommune && kommunenummer) {
            var kodelisteIdKommunenummer = (0, _kodeliste.kodelisteId)("".concat(inntektsaar, "_aktiveKommunenummer.").concat(kommunenummer));
            var txtKommune = intl.formatMessage({
                id: kodelisteIdKommunenummer
            });
            var txtKommuneInfo = "".concat(txtKommune, " (").concat(kommunenummer, ")");
            if (inline) {
                return (0, _compact.default)([
                    txtKommuneInfo,
                    adresseinfo,
                    matrikkelinfo,
                    andelsnr,
                    aksjeboenhetsnr,
                    bolignr
                ]).join(", ");
            } else {
                return /*#__PURE__*/ _react.default.createElement("div", null, txtKommuneInfo && /*#__PURE__*/ _react.default.createElement("div", null, txtKommuneInfo), adresseinfo && /*#__PURE__*/ _react.default.createElement("div", null, adresseinfo), matrikkelinfo && /*#__PURE__*/ _react.default.createElement("div", null, matrikkelinfo), andelsnr && /*#__PURE__*/ _react.default.createElement("div", null, andelsnr), aksjeboenhetsnr && /*#__PURE__*/ _react.default.createElement("div", null, aksjeboenhetsnr), bolignr && /*#__PURE__*/ _react.default.createElement("div", null, bolignr));
            }
        }
        if (inline) {
            return (0, _compact.default)([
                adresseinfo,
                matrikkelinfo,
                andelsnr,
                aksjeboenhetsnr,
                bolignr
            ]).join(", ");
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, adresseinfo && /*#__PURE__*/ _react.default.createElement("div", null, adresseinfo), matrikkelinfo && /*#__PURE__*/ _react.default.createElement("div", null, matrikkelinfo), andelsnr && /*#__PURE__*/ _react.default.createElement("div", null, andelsnr), aksjeboenhetsnr && /*#__PURE__*/ _react.default.createElement("div", null, aksjeboenhetsnr), bolignr && /*#__PURE__*/ _react.default.createElement("div", null, bolignr));
    }
};
var formaterLandFraKodeliste = function(intl, inntektsaar, landkode) {
    if (!landkode) {
        return "";
    }
    var id = (0, _kodeliste.kodelisteId)("".concat(inntektsaar, "_aktiveLandkoder.").concat(landkode));
    if (!id) {
        return "";
    }
    return intl.formatMessage({
        id: id
    });
};
var fastEiendom = {
    navn: "Eiendomstype",
    description: "Denne transformeren benyttes ved visning av eiendomstype",
    transform: function transform(felt, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl;
        var eiendomstype = (0, _get.default)(felt, "transformer.args", {}).eiendomstype;
        if (eiendomstype) {
            data = _object_spread_props(_object_spread({}, data), {
                eiendomstype: eiendomstype
            });
        }
        var txtEiendomsinfo = formaterEiendomsinfoOgSted(data, options);
        return inline || intl ? txtEiendomsinfo : /*#__PURE__*/ _react.default.createElement("div", null, txtEiendomsinfo);
    }
};
var formatertTekst = {
    navn: "Formattert Tekst",
    description: "Denne transformeren kombinerer tekst fra tekstkatalog med teknisk referanse",
    verditype: _transformKonstanter.verditype.formatertTekst,
    transform: function(felt, data, options) {
        var _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl, _options_returnerId = options.returnerId, returnerId = _options_returnerId === void 0 ? false : _options_returnerId;
        var tekstId = (0, _get.default)(felt, "transformer.verdi", "");
        if (returnerId) {
            return tekstId;
        }
        var message = intl.formatMessage({
            id: tekstId
        }, _object_spread({}, data));
        return inline ? message : /*#__PURE__*/ _react.default.createElement("div", null, message);
    }
};
var kombinert = {
    navn: "Kombinert (ikke bruk)",
    description: "Denne transformeren kombinerer statisk tekst og teknisk referanse",
    transform: function(felt, data, options) {
        var _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline;
        var verdi = (0, _get.default)(felt, "transformer.verdi", "");
        var referanser = kombinert.referanser(verdi);
        var kombinertTekst = verdi.replace(/\n/g, "<br/>");
        referanser.forEach(function(referanse) {
            var referanseVerdi = data[referanse] || referanse;
            kombinertTekst = kombinertTekst.replace("[".concat(referanse, "]"), referanseVerdi);
        });
        if (inline) {
            return kombinertTekst;
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, kombinertTekst);
    },
    referanser: function(verdi) {
        var rexp = /\[(.*?)\]/g;
        var referanser = [];
        var match = rexp.exec(verdi);
        while(match){
            referanser.push(match[1]);
            match = rexp.exec(verdi);
        }
        return referanser;
    }
};
var finnFormuesobjektByInternId = function(visningsdata, internId) {
    var forekomster = Object.entries((0, _pickBy.default)(visningsdata, _isArray.default));
    var formuesobjekt = (0, _flattenDepth.default)(forekomster, 2).filter(function(f) {
        return !f.utleietype;
    }).find(function(f) {
        return f.internEiendomsidentifikator === internId;
    });
    return formuesobjekt || {};
};
var tilhoerendeEiendom = {
    navn: "Tilh\xf8rende eiendom for tilleggseiendom",
    description: "Denne transformeren skal vise eiendomsinformasjon for tilh\xf8rende eiendom i kort, samtidig kunne bytte tilh\xf8rende eiendom i kortIDialog",
    transform: function(felt, data, options) {
        var visningsdata = options.visningsdata, inntektsaar = options.inntektsaar, erIDialog = options.erIDialog, _options_inline = options.inline, inline = _options_inline === void 0 ? false : _options_inline, intl = options.intl, _options_valgliste = options.valgliste, valgliste = _options_valgliste === void 0 ? [] : _options_valgliste;
        var tilhoerendeReferanse = (0, _get.default)(felt, "transformer", {}).tilhoerendeReferanse;
        var eiendommer = (0, _get.default)(visningsdata, tilhoerendeReferanse, []);
        var tilhoerendeForekomst;
        if (inntektsaar <= 2023) {
            var eiendom = eiendommer.find(function(v) {
                return v.internEiendomsidentifikator === data;
            });
            if (!eiendom) {
                return false;
            }
            var harDuplikateSergId = valgliste.length && eiendommer.filter(function(param) {
                var internEiendomsidentifikator = param.internEiendomsidentifikator;
                return valgliste.includes(internEiendomsidentifikator);
            }).filter(function(param) {
                var sergEiendomsidentifikator = param.sergEiendomsidentifikator;
                return sergEiendomsidentifikator === eiendom.sergEiendomsidentifikator;
            }).length > 1;
            tilhoerendeForekomst = _object_spread_props(_object_spread({}, eiendom, finnFormuesobjektByInternId(visningsdata, eiendom.internEiendomsidentifikator)), {
                harDuplikateSergId: harDuplikateSergId
            });
        } else {
            var eiendom1 = eiendommer.find(function(v) {
                return v.id === data;
            });
            if (!eiendom1) {
                return false;
            }
            var harDuplikateSergId1 = valgliste.length && eiendommer.filter(function(param) {
                var id = param.id;
                return valgliste.includes(id);
            }).filter(function(param) {
                var sergEiendomsidentifikator = param.sergEiendomsidentifikator;
                return sergEiendomsidentifikator === eiendom1.sergEiendomsidentifikator;
            }).length > 1;
            var finnFormuesobjekt = function(eiendom) {
                var formuesobjekter = eiendom.fastEiendomSomFormuesobjekt || [];
                return formuesobjekter.find(function(f) {
                    return f.eiendomstype !== _utils.TILLEGGSEIENDOM;
                }) || {};
            };
            tilhoerendeForekomst = _object_spread_props(_object_spread({}, eiendom1, finnFormuesobjekt(eiendom1)), {
                harDuplikateSergId: harDuplikateSergId1
            });
        }
        var txtEiendomsinfo = formaterEiendomsinfoOgSted(tilhoerendeForekomst, options);
        if (erIDialog) {
            var _formaterEiendomAdresse = formaterEiendomAdresse(tilhoerendeForekomst, intl), adresseinfo = _formaterEiendomAdresse.adresseinfo, matrikkelinfo = _formaterEiendomAdresse.matrikkelinfo, andelsnr = _formaterEiendomAdresse.andelsnr, aksjeboenhetsnr = _formaterEiendomAdresse.aksjeboenhetsnr, bolignr = _formaterEiendomAdresse.bolignr, boligInfo = _formaterEiendomAdresse.boligInfo;
            if (inline) {
                return (0, _compact.default)([
                    txtEiendomsinfo,
                    adresseinfo,
                    matrikkelinfo,
                    andelsnr,
                    aksjeboenhetsnr,
                    bolignr,
                    boligInfo
                ]).join(", ");
            }
            return /*#__PURE__*/ _react.default.createElement("span", null, txtEiendomsinfo, ", ", (0, _compact.default)([
                adresseinfo,
                matrikkelinfo,
                andelsnr,
                aksjeboenhetsnr,
                bolignr,
                boligInfo
            ]).join(", "));
        }
        if (inline) {
            return intl.formatMessage({
                id: "transformer.eiendommen.tilhoerer"
            }, {
                eiendom: txtEiendomsinfo
            });
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, intl.formatMessage({
            id: "transformer.eiendommen.tilhoerer"
        }, {
            eiendom: txtEiendomsinfo
        }), " ");
    }
};
var fnrTilFoedselsdato = {
    navn: "F\xf8dselsnummer til f\xf8dselsdato",
    description: "Denne transformeren benyttes ved visning f\xf8delsnummer hvor vi ikke \xf8nsker \xe5 vise de 5 siste sifferne",
    transform: function transform(felt, data) {
        if (typeof data !== "string" || data.trim().length <= 6) {
            return data;
        }
        return data.trim().substring(0, 6);
    }
};
